import Input from '@material-ui/core/Input';
import debounce from 'lodash/debounce';

import ClearIcon from '~/components/icons/ClearIcon';

import SearchIcon from './SearchIcon.svg';
import styles from './styles.style';

const DEBOUNCE_INTERVAL = 700;

class HeaderSearchField extends React.Component {
  inputRef = React.createRef();

  handleClear = () => {
    this.inputRef.current.value = '';
    this.props.onSearch(null);
  };

  handleSearch = debounce(this.props.onSearch, this.props.debounceInterval);

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSearch.cancel();
      this.props.onSearch(event.target.value);
    }
  };

  render() {
    const {
      classes,
      debounceInterval: _debounceInterval,
      onSearch: _onSearch,
      placeholder,
      searchQuery,
      ...props
    } = this.props;

    return (
      <Input
        inputProps={{
          ref: this.inputRef,
        }}
        classes={{
          root: classes.searchInput,
          input: classes.input,
        }}
        endAdornment={
          searchQuery && (
            <ClearIcon
              className={classes.clearFilterIcon}
              onClick={this.handleClear}
              width={16}
            />
          )
        }
        fullWidth
        onChange={(event) => {
          this.handleSearch(event.target.value);
        }}
        onKeyPress={this.handleKeyPress}
        placeholder={placeholder}
        defaultValue={searchQuery}
        startAdornment={<SearchIcon className={classes.searchIcon} />}
        {...props}
      />
    );
  }
}

HeaderSearchField.propTypes = {
  classes: PropTypes.object,
  debounceInterval: PropTypes.number,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
};

HeaderSearchField.defaultProps = {
  debounceInterval: DEBOUNCE_INTERVAL,
};

export default withStyles(styles)(HeaderSearchField);
